import keyBy from 'lodash/keyBy';

import { MemberActionTypes } from 'redux/actions/member';

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MemberActionTypes.SET_REPAIR_ORDERS:
      return {
        ...state,
        ...keyBy(action.value, 'id'),
      };
    default:
      return state;
  }
};

export default reducer;
